import { Action } from 'redux';

import { INotification } from '@models';
import {
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  IAddNotificationAction,
} from '@store/types/notification';

export const addNotification = (
  notification: INotification
): IAddNotificationAction => ({
  type: ADD_NOTIFICATION,
  payload: notification,
});

export const removeNotification = (): Action => ({
  type: REMOVE_NOTIFICATION,
});
